import { fetch } from '../../utils/dataAccess';

export const error = (error) => {
  return { type: 'ACCOUNT_SHOW_ERROR', error };
}

export const loading = (loading) => {
  return { type: 'ACCOUNT_SHOW_LOADING', loading };
}

export const success = (retrieved) => {
  return { type: 'ACCOUNT_SHOW_SUCCESS', retrieved };
}

export const retrieve = (id = 'me') => {
  return dispatch => {
    dispatch(loading(true));

    return fetch(id)
      .then(response =>
        response
          .json()
          .then(retrieved => {
            dispatch(loading(false));
            dispatch(success(retrieved.data));
          })
      )
      .catch(e => {
        dispatch(loading(false));
        dispatch(error(e.message));
      });
  };
}